//
//
//
//
//
//

import Vue from "vue";
import { NoticeBar } from "vant";
export default {
  components: {},
  data() {
    return {
      conText:"暂无公告"
    };
  },
  methods: {},
  created() {},
  mounted() {}
};
